// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AllFilters_wrap__2DuOO","quantity":"AllFilters_quantity___Xs1N"};